import { render, staticRenderFns } from "./AppealLetterQueue.vue?vue&type=template&id=97246c4e&"
import script from "./AppealLetterQueue.vue?vue&type=script&lang=js&"
export * from "./AppealLetterQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports